import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";import clsx from 'clsx';
import TableCell from "../../../TableCell";
import React from 'react';

import { createStyles } from "./styles";





























var AttributeCell = function AttributeCell(_ref)







{var productAttributes = _ref.productAttributes,attrId = _ref.attrId,link = _ref.link,isPortfolioAddedToCart = _ref.isPortfolioAddedToCart,isDisabled = _ref.isDisabled,showWideColumns = _ref.showWideColumns,_ref$cellStyle = _ref.cellStyle,cellStyle = _ref$cellStyle === void 0 ? '' : _ref$cellStyle;
  var classes = createStyles(showWideColumns);
  // Get attribute value from the list of all product attributes
  var currentProductAttr = _findInstanceProperty(productAttributes).call(productAttributes, function (_ref2) {var attributeId = _ref2.attributeId;return attributeId === attrId;});
  var currentProductAttrValue = (currentProductAttr === null || currentProductAttr === void 0 ? void 0 : currentProductAttr.displayValue) || '';
  return /*#__PURE__*/(
    React.createElement(TableCell, {
      className: clsx(
      cellStyle || classes.attributeCell,
      classes.attributeValueCell,
      cellStyle,
      isDisabled ? classes.disabledCell : isPortfolioAddedToCart && classes.selectedPortfolio // make cells green
      ) },



    link ? /*#__PURE__*/
    React.createElement("a", { href: currentProductAttr === null || currentProductAttr === void 0 ? void 0 : currentProductAttr.attributeValue, target: "_blank", rel: "noreferrer" },
    currentProductAttrValue) :


    currentProductAttrValue));



};

export default AttributeCell;
//# sourceMappingURL=index.js.map